import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

export interface TireDimension {
    width: string;
    aspectRatio: string;
    construction: string;
    diameter: string;
    fullDimension: string;
}

export interface TireDOT {
    manufacturingDate: string;
    manufacturingCode: string;
    dimensionCode: string;
    optionalCode: string;
}

export interface TireRecognitionResponse {
    success: boolean;
    errorMessage: string | null;
    tireDimension: TireDimension | null;
    loadIndex: string | null;
    speedIndex: string | null;
    tireBrand: string | null;
    tireLine: string | null;
    dot: TireDOT | null;
    carBrand: string | null;
    carModel: string | null;
    confidenceScore: number | null;
}

@Injectable({
    providedIn: 'root'
})
export class TireRecognitionService {
    private apiUrl = `${environment.cafler_backoffice_back_url}/tirerecognition`;

    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) { }

    recognizeTire(imageFile: File): Observable<TireRecognitionResponse> {
        if (!imageFile) {
            return throwError(() => new Error('No image file provided'));
        }

        if (imageFile.size > 10 * 1024 * 1024) {
            return throwError(() => ({
                status: 400,
                message: 'El archivo excede el tamaño máximo permitido de 10 MB'
            }));
        }

        const formData = new FormData();
        formData.append('image', imageFile);

        return from(this.authService.getAccessToken()).pipe(
            switchMap((token) => {
                if (!token) {
                    return throwError(() => new Error('No token available'));
                }

                const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

                return this.http.post<TireRecognitionResponse>(this.apiUrl, formData, { headers }).pipe(
                    map((response: TireRecognitionResponse) => {
                        if (!response.success) {
                            throw {
                                status: 400,
                                message: response.errorMessage || 'Error en el reconocimiento del neumático'
                            };
                        }
                        return response;
                    }),
                    catchError((error) => {
                        console.error('Tire recognition error:', error);
                        return throwError(() => error);
                    })

                );
            })
        );
    }
}
